// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"83248027","488":"5a14722d"}[chunkId] + ".chunk.js";
};